import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { IrrigationZone } from '../../_models/irrigation/irrigationZone';
import { Crop } from '../../_models';

@Injectable()
export class IrrigationZoneService {
  private apiBaseUrl = environment.apiBaseUrl;
  zoneItemObj: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  list: BehaviorSubject<Array<IrrigationZone>> = new BehaviorSubject<Array<IrrigationZone>>([]);
  insubstantialCrop = false;
  insubstantialVariety = false;

  constructor(private http: HttpClient) {}

  checkCropAndVariety(crop: Crop, commodityId, varietyId) {
    if (crop && crop.commodity && crop.commodity.id !== commodityId) {
      this.insubstantialCrop = true;
    } else {
      this.insubstantialCrop = false;
    }
    if (crop && crop.variety) {
      if (crop.variety.id !== varietyId) {
        this.insubstantialVariety = true;
      } else {
        this.insubstantialVariety = false;
      }
    }
  }

  getList(): Observable<IrrigationZone[]> {
    return this.http.get<any>(this.apiBaseUrl + 'api/private/v1/irrigation/irrigationZones').pipe(
      map((response) => {
        this.list.next(response);
        return response;
      })
    );
  }

  getExternalVarieties(varietyId, module?: string): Observable<any[]> {
    return this.http
      .get<any>(
        this.apiBaseUrl +
          'api/private/v1/irrigation/externalVarieties?commodity=' +
          varietyId +
          '&module=' +
          module
      )
      .pipe(map((response) => response));
  }
}
